/**
 * @description Removes Markdown formatting from a text string.
 *
 * @param {string} text - The Markdown-formatted text to be cleaned
 * @returns {string} Plain text with all Markdown syntax removed
 *
 * @example
 * // Returns: "Hello world"
 * removeMarkdown("# Hello **world**")
 *
 * @example
 * // Returns: "Click here to visit website"
 * removeMarkdown("[Click here](https://example.com) to visit website")
 */
export const removeMarkdown = (text: string): string => (
	text
		// Remove headers
		.replace(/#{1,6}\s/g, '')
		// Remove bullet points
		.replace(/[*-]\s/g, '')
		// Remove bold/italic
		.replace(/[*_]{1,2}([^*_]+)[*_]{1,2}/g, '$1')
		// Remove links
		.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
		// Remove blockquotes
		.replace(/^\s*>\s*/gm, '')
		// Remove code blocks
		.replace(/`{1,3}[^`]*`{1,3}/g, '')
		// Remove image tags
		.replace(/!\[.*?\]\(.*?\)/g, '')
		// Replace multiple newlines with a single space
		.replace(/\n+/g, ' ')
		// Remove extra spaces
		.replace(/\s+/g, ' ')
		// Remove underlines
		.replace(/<\/?u>/g, '')
		.trim()
);
